import { APP_ROUTES, PROVIDER_SELECTION_ROUTE_PATHS } from "@src/constants";

const DEFAULT_PROVIDER_SELECTION_PATH = APP_ROUTES.PROVIDER_PROFILE;

const ALLOWED_PROVIDER_SELECTION_PATHS = new Set(PROVIDER_SELECTION_ROUTE_PATHS);

export const resolveProviderSelectionPath = (providerBackPath?: string): string => {
  return providerBackPath && ALLOWED_PROVIDER_SELECTION_PATHS.has(providerBackPath)
    ? providerBackPath
    : DEFAULT_PROVIDER_SELECTION_PATH;
};
